var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgShirt = function SvgShirt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 45,
    height: 26,
    viewBox: "0 0 1.02 0.59",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.4.06C.39.2.4.22.24.26.16.28.11.28.08.36.04.45.04.51.13.51c.15 0 .29 0 .44.01.08.01.26.01.33.01C.93.52.95.54.96.48.97.37.93.31.83.28.76.25.7.28.64.18.64.17.63.1.63.08",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.11,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M.29.22c.17.34.44.03.44.03.04.01.14.02.16.05.05.06.1.21-.03.22C.76.53.53.53.42.53.34.53.04.55.03.44.02.34.15.23.24.23L.29.22z",
    fill: "#000",
    stroke: "#000",
    strokeWidth: 0.04,
    strokeMiterlimit: 22.9256
  })));
};

export default SvgShirt;